// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4950c366","488":"c634631a","570":"676e8778","780":"487797e9","977":"6036609e"}[chunkId] + ".chunk.js";
};